import { Box, Button, Theme, Typography, styled } from '@mui/material';

import UploadCloudSVG from '@common/assets/icons/UploadCloud.svg';

export const FileUploadSection = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	maxWidth: '100%',
});

export const FileUploadWrap = styled('div')(
	({ isDragOver, isError, theme }: { isDragOver: boolean; isError: boolean; theme: Theme }) => ({
		position: 'relative',
		border: '1px dashed #00000040',
		display: 'flex',
		alignItems: 'center',
		padding: '16px 24px',
		borderRadius: '10px',
		cursor: 'pointer',
		minHeight: '80px',

		...(isDragOver && {
			boxShadow: 'inset 0 0 0 1px rgba(13, 42, 148, 0.25)',
		}),
		...(isError && { borderColor: theme.palette.error.contrastText }),
	}),
);

export const UploadCloudIcon = styled(UploadCloudSVG)({
	width: '48px',
	minWidth: '48px',
	height: '48px',
	flex: 1,
});

export const FileUploadInsideWrap = styled('div')(({ theme }) => ({
	height: '100%',
	width: '100%',
	display: 'flex',
	flex: 1,
	gap: '24px',
	alignItems: 'center',
	justifyContent: 'center',

	[theme.breakpoints.down('sm')]: {
		flexDirection: 'column',
		gap: '12px',
	},
}));

export const FileUploadTextWrap = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '12px',
	flex: 2,
	textAlign: 'start',

	[theme.breakpoints.down('sm')]: {
		textAlign: 'center',
	},
}));

export const FileUploadErrortext = styled(Typography)(({ theme }) => ({
	color: theme.palette.error.contrastText,
	margin: 0,
	marginLeft: '16px',
}));

export const FileUploadButton = styled(Button)({
	background: '#FBFDFE',
	fontSize: '12px',
	lineHeight: '12px',
	padding: '12px 16px',
	height: '35px',
	textTransform: 'uppercase',
});
